import Queue from './Queue';
import { sendErrorAtDev } from './utils';
import httpRequest from './httpRequest';
var svgQueue = new Queue();
export default function loadSvgWithCached(url, callback) {
  if (svgQueue.cache.has(url)) {
    var cacheValue = svgQueue.cache.get(url);
    // 页面中有多处相同url请求，只请求一次，并保存多个callback，等待数据加载成功后统一回调
    if (cacheValue === undefined) {
      svgQueue.add(url, callback);
      return;
    }
    if (cacheValue instanceof SVGSVGElement) {
      callback(null, cacheValue);
      return;
    }
  }
  svgQueue.cache.set(url, undefined);
  svgQueue.add(url, callback);
  httpRequest(url, function (error, xhr) {
    if (error) {
      sendErrorAtDev(error);
      svgQueue.cache.set(url, error);
    } else if (xhr.responseXML instanceof Document && xhr.responseXML.documentElement && xhr.responseXML.documentElement instanceof SVGSVGElement) {
      svgQueue.cache.set(url, xhr.responseXML.documentElement);
    }
    svgQueue.run(url);
  });
}